import React, { useEffect } from 'react';

/**
 * Performance monitoring component that tracks key metrics
 * and reports them to the console in development mode
 */
const PerformanceMonitor = () => {
  useEffect(() => {
    // Only run in development mode
    if (import.meta.env.DEV) {
      // Track initial page load performance
      const observer = new PerformanceObserver(list => {
        const entries = list.getEntries();
        entries.forEach(entry => {
          if (entry.entryType === 'navigation') {
            console.group('📊 Page Performance Metrics');
            console.log(
              `🚀 DOM Content Loaded: ${entry.domContentLoadedEventEnd - entry.domContentLoadedEventStart}ms`
            );
            console.log(`⚡ Load Complete: ${entry.loadEventEnd - entry.loadEventStart}ms`);
            console.log(`🔄 DNS Lookup: ${entry.domainLookupEnd - entry.domainLookupStart}ms`);
            console.log(`🤝 Connection: ${entry.connectEnd - entry.connectStart}ms`);
            console.groupEnd();
          }

          if (entry.entryType === 'largest-contentful-paint') {
            console.log(`🎨 Largest Contentful Paint: ${entry.startTime}ms`);
          }

          if (entry.entryType === 'first-input') {
            console.log(`👆 First Input Delay: ${entry.processingStart - entry.startTime}ms`);
          }
        });
      });

      observer.observe({ entryTypes: ['navigation', 'largest-contentful-paint', 'first-input'] });

      // Track memory usage if available
      if ('memory' in performance) {
        const logMemory = () => {
          const memory = performance.memory;
          console.group('💾 Memory Usage');
          console.log(`Used: ${(memory.usedJSHeapSize / 1048576).toFixed(2)} MB`);
          console.log(`Total: ${(memory.totalJSHeapSize / 1048576).toFixed(2)} MB`);
          console.log(`Limit: ${(memory.jsHeapSizeLimit / 1048576).toFixed(2)} MB`);
          console.groupEnd();
        };

        // Log memory usage every 30 seconds
        const memoryInterval = setInterval(logMemory, 30000);

        return () => {
          clearInterval(memoryInterval);
          observer.disconnect();
        };
      }

      return () => {
        observer.disconnect();
      };
    }
  }, []);

  // This component doesn't render anything
  return null;
};

export default PerformanceMonitor;
